import { ThunkDispatch } from "core-integration/src/store";
import { getRenewableLeagues } from "core-integration/src/store/leagues/reducers";
import {
  deleteRenewableLeague,
  fetchRenewableLeagues,
  renewRenewableLeague,
} from "core-integration/src/store/leagues/thunks";
import React, { useEffect } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Box, Flex } from "rebass/styled-components";
import Alert from "../Alert";
import Button from "../Button";
import Copy from "../Copy";
import { Main, Wrapper } from "../Layout";
import SubHeading from "../SubHeading";
import Title from "../Title";

type Props = WithTranslation;

const Renew: React.FC<Props> = ({ t }) => {
  const dispatch = useDispatch<ThunkDispatch>();

  const leagues = useSelector(getRenewableLeagues);

  const destroy = async (id: number) => dispatch(deleteRenewableLeague(id));
  const renew = async (id: number) => dispatch(renewRenewableLeague(id));

  useEffect(() => {
    dispatch(fetchRenewableLeagues());
  }, [dispatch]);

  return (
    <Wrapper>
      <Main>
        <Copy>
          <Title>{t("renew.title", "Renew your leagues")}</Title>
          <p>
            {t(
              "renew.p1",
              "Choose whether you wish to renew or delete last season's private leagues.",
            )}
          </p>
          <p>
            {t(
              "renew.p2",
              "All players from last season will automatically be entered into the renewed league(s) when they join the game.",
            )}
          </p>

          {leagues.length ? (
            <ul>
              {leagues.map((l) => (
                <li key={l.id}>
                  <SubHeading>{l.name}</SubHeading>
                  <Flex>
                    <Box mr={2}>
                      <Button onClick={() => renew(l.id)}>
                        {t("renew.buttons.renew", "Renew")}
                      </Button>
                    </Box>
                    <Box>
                      <Button onClick={() => destroy(l.id)}>
                        {t("renew.buttons.delete", "Delete")}
                      </Button>
                    </Box>
                  </Flex>
                </li>
              ))}
            </ul>
          ) : (
            <Box mb={4}>
              <Alert type="info">
                {t("renew.none", "You have no leagues to renew.")}
              </Alert>
            </Box>
          )}
        </Copy>
      </Main>
    </Wrapper>
  );
};

export default withTranslation()(Renew);
